const doc = [({"ja":({"draft":"下書き", "published":"公開"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;